export default "__VITE_ASSET__CNIslLSo__"